import { TokenReissueResponse } from '@/apis/handler/auth/authSchema';
import axios from 'axios';
import { useInfoStore } from 'store/useInfoStore';

export const request = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 20000,
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true,
});

request.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const { accessToken: latestToken } = useInfoStore.getState();
      config.headers.Authorization = latestToken ? `Bearer ${latestToken}` : '';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const { data } = await axios.post<TokenReissueResponse>(
          `${process.env.REACT_APP_API}/auth/token/reissue/member`,
          {},
          { withCredentials: true },
        );

        // NOTE: http code is returned as 200 even if the request is failed. so we need to check isSuccess
        // NOTE: 1. refresh  토큰이 만료되면 아래 조건문이 실행됩니다.
        if (!data.isSuccess) {
          useInfoStore.getState().resetInfo?.();

          // NOTE: user should be logged out even when token is expired
          // NOTE: 2. refresh 토큰이 만료된 상태에서 로그아웃 요청을 보내면 400번대 에러가 발생하기 때문에 에러를 던지게 됩니다
          await axios.post(`${process.env.REACT_APP_API}/auth/logout`);
        }

        const newAccessToken = data.result.accessToken;

        useInfoStore.getState().setInfo({ ...useInfoStore.getState().getInfo(), accessToken: newAccessToken });

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        return axios(originalRequest);
      } catch (refreshError) {
        // NOTE: 3. 에러를 전달받고, 메인 페이지로 이동하도록 합니다
        console.error('refreshError', refreshError);

        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  },
);
